import { render, staticRenderFns } from "./LineChart2.vue?vue&type=template&id=24fabcd4&scoped=true"
import script from "./LineChart2.vue?vue&type=script&lang=js"
export * from "./LineChart2.vue?vue&type=script&lang=js"
import style0 from "./LineChart2.vue?vue&type=style&index=0&id=24fabcd4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fabcd4",
  null
  
)

export default component.exports